import ReducerUtils from "../../../utils/ReducerUtils"
import Actions      from "../../../model/constant/actions"


const savingIdentityVariants = ReducerUtils.createReducer(false,{
  [Actions.SAVING_IDENTITY_VARIANTS] : (state,action)=>action.status,
})

export default savingIdentityVariants